module.exports = __webpack_public_path__ + "img/237.17962a00.jpg";